import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 8px 0;
  justify-content: space-between;
  margin: 0 20px;
`;

export const ActionContainer = styled.div`
  align-items: center;
  display: flex;
`;

export const SpaceRightMixin = css`
  margin-right: 15px;
`;

export const RecordBtnMixin = css`
  .panda-typography--P1 {
    font-size: 14px;
    font-weight: 500;
  }
  .panda-icon.space-right-small {
    margin-right: 10px;
  }
  .panda-icon.space-left-small {
    margin-left: 10px;
  }
`;
